import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './CustomToastStyles.css';
import useAuth from './useAuth';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';

function Add_Store_Form() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem('authToken');
    const navigate = useNavigate();
    const [vehicleNumbers, setVehicleNumbers] = useState([]);
    const [vehicleMakes, setVehicleMakes] = useState([]);
    const [error, setError] = useState('');
    const [EmpCode, setEmpCode] = useState('');
    const [uploadError, setUploadError] = useState("");
    const [Grade, setGrade] = useState('');
    const [loading, setLoading] = useState(true);
    const [responseMessage, setResponseMessage] = useState('');
    const Loader = () => (
        <div className="loader-container1">
            <div className="spinner1"></div>
            <p>Loading...</p>
        </div>
    );
    const [formData, setFormData] = useState({
        comp_name: '',
        emp_code: '',
        grade: '',
        dept_name: '',
        designation_name: '',
        report_mngr: '',
        mode_of_travel: '',
        to_city: '',
        guesthouse: '',
        bank_acnum: '',
        bank_name: '',
        ifsc_code: '',
        total_fuel_amt: '',
        total_fuel_qty: '',
        img: []  // To store the image files
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitAllowed, setIsSubmitAllowed] = useState(true);
    const [transportRows, setTransportRows] = useState([{
        id: 1,
        dated: '',          // Repair Date
        repair_time: '',     // Repair Time
        driver_bmid: '',           // Driver BMID
        purpose: '',         // Purpose
        fuel_amount: '',     // Amount
        remarks: '',         // Remarks
        meter_reading: '',   // Meter Reading
        meter_reading_image: [] // Attachment
    }]);


    useAuth();  // Custom hook for authentication

    const handleBackClick = () => {
        navigate("/manage_fuel_forms");
    };

    const handleAddTransportRow = () => {
        setTransportRows([
            ...transportRows,
            {
                id: transportRows.length + 1,
                dated: '', // Repair Date
                repair_time: '', // Repair Time
                driver_bmid: '', // Driver Bmid
                purpose: '', // Purpose
                fuel_amount: '', // Amount
                remarks: '', // Remarks
                meter_reading: '', // Meter Reading
                meter_reading_image: [], // Attachment
            }
        ]);
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };




    // fetch vehicle makes
    const fetchVehicleMakes = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}getVehicleDrivers`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status) {
                setVehicleMakes(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch items');
        } finally {
            // setLoading(false);
        }
    };

    useEffect(() => {
        const loadAllData = async () => {
            try {
                await Promise.all([

                    fetchVehicleMakes()
                ]);
            } catch (error) {
                console.error('Error loading data:', error);
            } finally {
                //  setLoading(false);
            }
        };

        loadAllData();
    }, [navigate]);



    const handleTransportChange = async (index, e) => {
        const { name, value, type, files, id } = e.target;
        const newTransportRows = [...transportRows];
        newTransportRows[index] = { ...newTransportRows[index], [name]: value };


        const MAX_SIZE = 1 * 1024 * 1024; // 1MB in bytes

        // If the input type is 'file' and there are selected files
        if (type === 'file' && files.length > 0) {
            const file = files[0]; // Get the first selected file

            if (file.type === 'application/pdf') {
                // Directly store PDF file without resizing
                newTransportRows[index] = { ...newTransportRows[index], [name]: file };
            } else {
                try {
                    const resizedFile = await resizeImage(file, 1024, 1024, 1); // Resize only images
                    newTransportRows[index] = { ...newTransportRows[index], [name]: resizedFile };
                } catch (error) {
                    toast.error(error.message);
                    return;
                }
            }
        } else {
            newTransportRows[index] = { ...newTransportRows[index], [name]: value };
        }





        // Update the transport rows state
        setTransportRows(newTransportRows);
    };

    const resizeImage = (file, maxWidth, maxHeight, maxSizeMB) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;

                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    let width = img.width;
                    let height = img.height;

                    // Maintain aspect ratio while resizing
                    if (width > maxWidth || height > maxHeight) {
                        if (width > height) {
                            height *= maxWidth / width;
                            width = maxWidth;
                        } else {
                            width *= maxHeight / height;
                            height = maxHeight;
                        }
                    }

                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);

                    // Convert canvas to Blob and check size
                    canvas.toBlob((blob) => {
                        if (blob.size > maxSizeMB * 1024 * 1024) {
                            reject(new Error(`Resized file still exceeds ${maxSizeMB}MB.`));
                        } else {
                            resolve(new File([blob], file.name, { type: file.type }));
                        }
                    }, file.type, 0.8); // Adjust quality (0.8 = 80%)
                };
            };

            reader.onerror = (error) => reject(error);
        });
    };



    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const MAX_SIZE = 1 * 1024 * 1024;
        const MAX_WIDTH = 1024;
        const MAX_HEIGHT = 1024;

        let errorMessages = [];
        const validFiles = [];

        files.forEach(file => {
            if (file.type === "application/pdf") {
                // Accept PDFs directly if they are within size limit
                if (file.size > MAX_SIZE) {
                    toast.error(`PDF "${file.name}" exceeds the 1MB limit.`);
                } else {
                    validFiles.push(file);
                    processFiles(validFiles);
                }
            } else if (file.size > MAX_SIZE) {
                //errorMessages.push(`File "${file.name}" exceeds the 1MB limit. Resizing...`);
                resizeImage(file, MAX_WIDTH, MAX_HEIGHT, (resizedFile) => {
                    validFiles.push(resizedFile);
                    processFiles(validFiles);
                });
            } else {
                validFiles.push(file);
            }
        });

        if (validFiles.length === 0) return; // Stop if all files are invalid

        // Convert valid files to Base64
        processFiles(validFiles);
    };


    const processFiles = (files) => {
        const fileReaders = files.map(file => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        });

        Promise.all(fileReaders)
            .then(base64Files => {
                setFormData(prevData => ({
                    ...prevData,
                    img: base64Files
                }));
            })
            .catch(error => {
                console.error("Error reading files:", error);
            });
    };





    const handleRemoveTransportRow = (index) => {
        if (transportRows.length > 1) {
            setTransportRows(transportRows.filter((_, i) => i !== index));
        }
    };



    useEffect(() => {
        const fetchProfileData = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${API_BASE_URL}profile`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                console.log("Profile data:", result); // Log to check fetched data

                if (result.status) {
                    const { profile } = result;

                    // Set default values from profile
                    setEmpCode(profile.emp_code || '');
                    setGrade(profile.grade || '');
                    setFormData(prevData => ({
                        ...prevData,
                        comp_name: profile.comp_name || '',
                        emp_code: profile.emp_code || '',
                        dept_name: profile.dept_name || '',
                        designation_name: profile.designation_name || '',
                        grade: profile.grade || '',
                        report_mngr: profile.report_mngr || '',
                        mobile: profile.mobile || '', // Do not display the password
                        bank_acnum: profile.bank_acnum || '',
                        bank_name: profile.bank_name || '',
                        ifsc_code: profile.ifsc_code || '',
                        location_name: profile.location_name || '',
                    }));
                } else {
                    setResponseMessage('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchProfileData();
    }, []);



    const calculateTotal = () => {
        // Calculate the total amount, make total of all total_fuel_amt rows
        const total_amt = transportRows.reduce((total, row) => total + (parseFloat(row.fuel_amount) || 0), 0);
        return total_amt


    };




    useEffect(() => {
        calculateTotal();


    }, [transportRows]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isSubmitAllowed) {
            toast.error("Please fix the file size errors before submitting.");
            return;
        }
        if (isSubmitting) return;
        setIsSubmitting(true);
        // Convert a file to Base64
        const convertToBase64 = (file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result); // Keep full Base64 string
                reader.onerror = (error) => reject(error);
            });
        };

        // Convert images to Base64
        const transportRowsWithBase64 = await Promise.all(
            transportRows.map(async (row) => ({
                ...row,
                meter_reading_image: row.meter_reading_image instanceof File ? await convertToBase64(row.meter_reading_image) : row.meter_reading_image
            }))
        );

        // Convert images to Base64
        const imgBase64Array = await Promise.all(
            formData.img.map(async (file) =>
                file instanceof File ? await convertToBase64(file) : file
            )
        );

        try {
            // Create a JSON object instead of FormData
            const formDataToSend = {
                comp_name: formData.comp_name,
                emp_code: formData.emp_code,
                grade: formData.grade,
                dept_name: formData.dept_name,
                designation_name: formData.designation_name,
                mobile: formData.mobile,
                report_mngr: formData.report_mngr,
                bank_acnum: formData.bank_acnum,
                bank_name: formData.bank_name,
                ifsc_code: formData.ifsc_code,
                location_name: formData.location_name,
                total_repair_amt: calculateTotal(),
                transportRows: transportRowsWithBase64,
                img: imgBase64Array,
                // transportRows: transportRows.map(row => ({
                //     ...row,
                //     meter_reading_image: row.meter_reading_image ? row.meter_reading_image.name : null // Store only the file name
                // }))
            };

            const token = localStorage.getItem('authToken');
            const response = await fetch(`${API_BASE_URL}addRepairForm`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formDataToSend) // Convert object to JSON string
            });

            const result = await response.json();
            if (result.status) {
                toast.success('Repair Form submitted successfully!');
                setTimeout(() => {
                    navigate('/edit_repair_form/' + result.id);
                }, 2000);
            } else {
                toast.error(result.message || 'An error occurred while submitting the form.');
            }
        } catch (error) {
            console.error('Submission error:', error);
            toast.error('Failed to submit form');
        } finally {
            setIsSubmitting(false);
        }
    };




    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0" style={{ fontSize: '20px' }}>Add New Store Form</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
                                        <li className="breadcrumb-item active">New Store Form</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <Loader /> // Show loader if loading is true
                    ) : (
                        <>
                            <section className="col-lg-12">
                                <div className="card" style={{ borderTop: '3px solid #CC5500' }}>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit} method="post" acceptCharset="utf-8">
                                            
                                            <fieldset style={{ border: '1px #ccc solid', padding: '10px' }}>
                                                <center>
                                                    <span className="btn btn-warning" style={{ fontSize: '12px', color: 'white', backgroundColor: '#CC5500' }}>
                                                        Details of Repair Form
                                                    </span>
                                                </center>

                                                <div className="transport-table-container mb-3 text-right">
                                                    <button type="button" onClick={handleAddTransportRow} className="btn btn-sm btn-primary">+</button>

                                                    {/* Responsive Table Wrapper */}
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <td colSpan="12"></td>
                                                                </tr>
                                                                <tr className="header-row text-center">
                                                                    <th>Repair Date<span className="text-danger">*</span></th>
                                                                    <th>Repair Time<span className="text-danger">*</span></th>
                                                                    <th>Driver Bmid<span className="text-danger">*</span></th>
                                                                    <th>Purpose<span className="text-danger">*</span></th>
                                                                    <th>Amount</th>
                                                                    <th>Remarks</th>
                                                                    <th>Meter Reading</th>
                                                                    <th>Attachment</th>

                                                                    <th>Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {transportRows.map((row, index) => (
                                                                    <tr key={index}>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input
                                                                                type="date"
                                                                                name="dated"
                                                                                value={row.dated}
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                className="form-control input-font"
                                                                                max={new Date().toISOString().split("T")[0]}
                                                                                required={index === 0}
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input
                                                                                type="time"
                                                                                name="repair_time"
                                                                                value={row.repair_time}
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                className="form-control input-font"
                                                                                required={index === 0}
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '6rem' }}>

                                                                            <select
                                                                                className="form-control input-font"
                                                                                value={row.emp_code}
                                                                                name="driver_bmid"
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                required={index === 0}
                                                                            >
                                                                                <option value="">Select Driver id</option>
                                                                                {vehicleMakes.map((item) => (
                                                                                    <option key={item.emp_code} value={item.emp_code}>{item.emp_code}</option>
                                                                                ))}

                                                                            </select>


                                                                        </td>


                                                                        <td style={{ minWidth: '12rem' }}>

                                                                            <select
                                                                                className="form-control input-font"
                                                                                value={row.purpose}
                                                                                name="purpose"
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                required={index === 0}
                                                                            >
                                                                                <option value="">Select Purpose</option>
                                                                                <option value="office_purpose">Office Purpose</option>
                                                                                <option value="branch_visit">Branch Visit</option>
                                                                                <option value="patient">Patient</option>
                                                                                <option value="other_purpose">Other Purpose</option>

                                                                            </select>

                                                                        </td>

                                                                        <td style={{ minWidth: '6rem' }}>
                                                                            <input
                                                                                className="form-control input-font"
                                                                                type="number"
                                                                                value={row.fuel_amount}
                                                                                required={index === 0}
                                                                                name="fuel_amount"
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '4rem' }}>
                                                                            <input className="form-control input-font"
                                                                                type="text"
                                                                                value={row.remarks}
                                                                                name="remarks"
                                                                                onChange={(e) => { handleTransportChange(index, e) }}
                                                                                required={index === 0}
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '8rem' }}>
                                                                            <input className="form-control input-font"
                                                                                type="number"
                                                                                value={row.meter_reading}
                                                                                name="meter_reading"
                                                                                onChange={(e) => { handleTransportChange(index, e) }}
                                                                                required={index === 0}
                                                                            />
                                                                        </td>
                                                                        <td style={{ minWidth: '12rem' }}>
                                                                            <input
                                                                                type="file"
                                                                                name="meter_reading_image"
                                                                                id="meter_reading_image"
                                                                                accept=".jpg,.jpeg,.png,.pdf"
                                                                                onChange={(e) => handleTransportChange(index, e)}
                                                                                className="form-control input-font"
                                                                            />
                                                                        </td>

                                                                        <td>
                                                                            <button type="button" onClick={() => handleRemoveTransportRow(index)} className="btn btn-sm btn-danger">×</button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <td colSpan="4"></td>
                                                                    <td className="text-center font-weight-bold">
                                                                        Total Amt : ₹ {transportRows.reduce((total, row) => total + (parseFloat(row.fuel_amount) || 0), 0)}
                                                                    </td>

                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                            </fieldset>


                                            {/* Upload Images Section */}
                                            <section className="col-lg-12">
                                                {uploadError && <div className="alert alert-danger text-center p-2">{uploadError}</div>}

                                                <label className="font-weight-bold">Upload Multiple Images:</label>
                                                <input
                                                    type="file"
                                                    name="img"
                                                    multiple
                                                    accept=".jpg,.jpeg,.png,.pdf"
                                                    onChange={handleFileChange}
                                                    className="form-control mb-3"
                                                />

                                                {/* Buttons */}
                                                <div className="d-flex justify-content-center">
                                                    <button type="submit" className="btn btn-success">
                                                        {isSubmitting ? 'Creating New...' : 'Save'}
                                                    </button>
                                                    <button type="button" className="btn btn-secondary ml-3" onClick={handleBackClick}>
                                                        Cancel
                                                    </button>
                                                </div>
                                            </section>

                                        </form>
                                    </div>
                                </div>
                            </section>
                        </>
                    )}
                </div>
                <Footer />
            </div>
            <ToastContainer />
        </div>
    )
}

export default Add_Store_Form